import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
    Password
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const Otp = () => {
    const [posting, setPosting] = useState(false);
    const [identifier, setIdentifier] = useState("");
    const [type, setType] = useState("");
    const [otp, setOtp] = useState("");
    const [timeLeft, setTimeLeft] = useState(60);
    const navigate = useNavigate();

    const handleOtpVerify = async () => {

        if (identifier === "") {
            toast.warn("Failed. No registered email found for your OTP", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (otp === "") {
            toast.warn("Failed. Fill in the OTP we sent you", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        setPosting(true);
        const dataObj = {
            identifier,
            type,
            otp,
        }

        console.log(dataObj);
        //Today
        const baseUrl = apilink.link;
        await axios
            .post(`${baseUrl}/auth/verify-otp`, dataObj, {
                headers: {
                    "Content-Type": "application/json",
                },
            })

            .then((response) => {
                setPosting(false);
                if (response.data.message === "Account activated. You can now login.") {
                    toast.success("Verification successfull. You can now login to your account", {
                        position: "top-center",
                        hideProgressBar: true,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        onClose: () => {
                            navigate("/");
                        },
                        theme: "light",
                    });
                }
            })
            .catch((error) => {
                setPosting(false);
                console.log(error);
                if (error.response.data.message === "OTP expired") {
                    toast.warn("Failed. Your OTP expired. Click resend OTP to get a new one", {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            });

    };

    const handleOtpResend = async () => {
        if (identifier === "") {
            toast.warn("Failed. You have not done any registration yet. Register first", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }

        setPosting(true);
        const dataObj = {
            identifier,
            type
        }

        console.log(dataObj);
        //Today
        const baseUrl = apilink.link;
        await axios
            .post(`${baseUrl}/auth/resend-otp`, dataObj, {
                headers: {
                    "Content-Type": "application/json",
                },
            })

            .then((response) => {
                setPosting(false);
                if (response.data.message === 'OTP resent successfully') {
                    toast.success("OTP successfully sent again", {
                        position: "top-center",
                        hideProgressBar: true,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        onClose: () => {
                            setTimeLeft(60);
                        },
                        theme: "light",
                    });

                }
            })
            .catch((error) => {
                setPosting(false);
                console.log(error);
                if (error.response.data.message === 'Account already activated') {
                    toast.warn("Failed. Your account is already activated", {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
                if (error.response.data.message === 'User not found') {
                    toast.warn("Failed. Your account is not found in system", {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            });
    };


    useEffect(() => {

        const getAsyncData = async () => {
            const regData = await JSON.parse(
                localStorage.getItem("userReg")
            );
            console.log("code: " + regData.identifier);
            setIdentifier(regData.identifier);
            setType(regData.id_type);
        };
        getAsyncData();

    }, []);

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [timeLeft]);


    return (
        <>
            <div
                style={{
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "56px",
                    paddingInline: 30,
                }}
            >
                <img
                    alt="logo"
                    style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
                    src={require("./logo.png")}
                />
                <h1
                    className="navbar-brand mb-0"
                    style={{ fontFamily: "Caveat", fontSize: 38 }}
                >
                    <b>Collide - </b> Dating
                </h1>
                <p
                    style={{
                        color: "#010832",
                        fontFamily: "Open Sans",
                        marginTop: "30px",
                    }}
                >
                    OTP Confirmation
                </p>
                <p
                    style={{
                        color: "#00000090",
                        fontFamily: "Open Sans",
                        marginTop: "10px",
                        fontSize: "12px"
                    }}
                >
                    <center>
                        Check your email or phone and <br /> enter the confirmation code below.
                    </center>
                </p>
                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Password style={{ color: "#ffffff", marginTop: '15px' }} />
                        <p style={{ color: '#ffffff', fontSize: '8pt' }}>OTP</p>
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <input
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={otp}
                            placeholder="Received OTP"
                            onChange={(e) => { setOtp(e.target.value) }}
                        />
                    </div>
                    <div></div>
                </div>

                <button
                    onClick={() => handleOtpVerify()}
                    style={{
                        width: "320px",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        border: "none",
                        height: 50,
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        color: "white",
                        marginTop: "10px",
                    }}
                >
                    {posting === false && <>Verify OTP</>}
                    {posting && (
                        <>
                            <Squares />
                        </>
                    )}
                </button>

                {timeLeft > 0 ? (
                    <p
                        style={{
                            color: "#000000",
                            fontFamily: "Open Sans",
                            fontSize: 14,
                            marginTop: "20px",
                            alignSelf: "left",
                            width: "320px",
                        }}
                    >
                        Did not receive OTP &nbsp;?&nbsp; <span style={{ color: "#010832" }}>Resend OTP in {timeLeft}</span>
                    </p>
                ) : (
                    <p
                        onClick={() => handleOtpResend()}
                        style={{
                            color: "#000000",
                            fontFamily: "Open Sans",
                            fontSize: 14,
                            marginTop: "20px",
                            alignSelf: "left",
                            width: "320px",
                        }}
                    >
                        Did not receive OTP &nbsp;?&nbsp; <span style={{ color: "#010832" }}>Click here to Resend</span>
                    </p>
                )}


                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </div>
        </>
    );
};

export default Otp;
